import { Flex, FlexProps, useMediaQuery, Container, LightMode } from '@chakra-ui/react'
import * as React from 'react'
import { Helmet } from 'react-helmet'

type PageWrapProps = FlexProps & {
  title: string
}

const PageWrap = React.forwardRef<HTMLDivElement, PageWrapProps>(
  ({ children, title, px, ...rest }, ref) => {
    const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Flex {...rest} px={isTabletOrMobile ? 4 : px} ref={ref}>
          <LightMode>
            <Container maxW="container.xl">{children}</Container>
          </LightMode>
        </Flex>
      </>
    )
  }
)

PageWrap.defaultProps = {
  flex: 1,
  bg: 'gray.50',
  pt: 'calc(64px + 1rem)',
  pb: 24,
  px: 8,
  height: '100%',
  flexDir: 'column',
  minHeight: '100vh',
  align: 'flex-start',
  justify: 'flex-start'
}

export default PageWrap
